/**
 * 地圖「目前位置」控制：開＝顯示圖示並跟隨，關＝拿掉圖示。
 * 座標只在瀏覽器，不上傳伺服器。
 */

const ICON = L.divIcon({
    className: 'my-location-marker',
    html: '<span class="my-location-dot" aria-hidden="true"></span>',
    iconSize: [22, 22],
    iconAnchor: [11, 11]
});

export function attachMyLocationControl(map) {
    if (!map || map._myLocationControl) return map._myLocationControl || null;

    const Control = L.Control.extend({
        options: { position: 'topleft' },

        onAdd(map) {
            this._map = map;
            const wrap = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-mylocation');
            const btn = L.DomUtil.create('a', '', wrap);
            btn.href = '#';
            btn.role = 'button';
            btn.title = '顯示目前位置';
            btn.setAttribute('aria-label', '顯示目前位置');
            btn.setAttribute('aria-pressed', 'false');
            btn.innerHTML = '<span class="my-location-btn-icon">◎</span>';
            L.DomEvent.disableClickPropagation(wrap);
            L.DomEvent.on(btn, 'click', (ev) => {
                L.DomEvent.preventDefault(ev);
                this.toggle();
            });
            this._btn = btn;
            return wrap;
        },

        toggle() {
            if (this._on) this.turnOff();
            else this.turnOn();
        },

        turnOn() {
            if (!navigator.geolocation) {
                this._btn.title = '此瀏覽器不支援定位';
                return;
            }
            this._on = true;
            this._btn.classList.add('is-on');
            this._btn.setAttribute('aria-pressed', 'true');
            this._btn.title = '關閉目前位置圖示';
            this._panned = false;
            this._watchId = navigator.geolocation.watchPosition(
                (pos) => this._onFix(pos),
                (err) => this._onError(err),
                { enableHighAccuracy: true, maximumAge: 4000, timeout: 20000 }
            );
        },

        turnOff() {
            this._on = false;
            this._btn.classList.remove('is-on');
            this._btn.setAttribute('aria-pressed', 'false');
            this._btn.title = '顯示目前位置';
            if (this._watchId != null && navigator.geolocation) {
                navigator.geolocation.clearWatch(this._watchId);
            }
            this._watchId = null;
            if (this._marker) {
                this._map.removeLayer(this._marker);
                this._marker = null;
            }
            if (this._circle) {
                this._map.removeLayer(this._circle);
                this._circle = null;
            }
        },

        _onFix(pos) {
            if (!this._on) return;
            const lat = pos.coords.latitude;
            const lng = pos.coords.longitude;
            const acc = Number(pos.coords.accuracy) || 0;
            const ll = L.latLng(lat, lng);
            if (!this._marker) {
                this._marker = L.marker(ll, { icon: ICON, interactive: false, keyboard: false })
                    .addTo(this._map);
            } else {
                this._marker.setLatLng(ll);
            }
            if (acc > 0 && acc < 2000) {
                if (!this._circle) {
                    this._circle = L.circle(ll, {
                        radius: acc,
                        color: '#2563eb',
                        weight: 1,
                        fillColor: '#2563eb',
                        fillOpacity: 0.12,
                        interactive: false
                    }).addTo(this._map);
                } else {
                    this._circle.setLatLng(ll);
                    this._circle.setRadius(acc);
                }
            }
            if (!this._panned) {
                this._panned = true;
                const z = this._map.getZoom();
                this._map.setView(ll, z < 15 ? 16 : z, { animate: true });
            }
        },

        _onError(err) {
            const msg = err?.code === 1
                ? '未允許定位，圖示無法顯示'
                : '暫時無法取得位置';
            this._btn.title = msg;
            this.turnOff();
            this._btn.title = msg;
        }
    });

    const ctl = new Control();
    ctl.addTo(map);
    map._myLocationControl = ctl;
    return ctl;
}
